import {noop} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {FrontClickEvent} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {InfoBubblePillVariantsEnum} from '../../../common/infoBubbles/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Component.
 */

export const ChatShowcaseKnowledgeBaseEducationTip: FC<SandboxEducationTipProps> = (props) => {
  const {trackDataEvent} = useDataEventTracking();

  const onNextClick = (event: FrontClickEvent) => {
    trackDataEvent(
      DataEventActionsEnum.CLICK,
      OnboardingDataEventObject.DEMO_CHAT_SHOWCASE_KNOWLEDGE_BASE,
      {},
    );
    props.onNextClick(event);
  };

  return (
    <EducationTip
      anchor={props.anchor}
      position="left-start"
      isInteractive
      isVisible={props.isVisible}
      // Make it look nicer with the corners of the chat preview article.
      overlayBorderRadius={20}
      // Don't do any scrolling, since the chat preview takes care of that.
      scrollsIntoView={false}
      onRequestClose={noop}
      pillType={InfoBubblePillVariantsEnum.EDUCATION}
      title={
        <Trans id="infobubble-onboarding-chat-showcase-knowledge-base-title">
          A knowledge base article resolved a simple question
        </Trans>
      }
      stepCounter={generateStepText(2, 3)}
      onPrimaryClick={onNextClick}
      primaryActionLabel={<Trans id="infobubble-onboarding-chat-showcase-knowledge-base-primary">Next</Trans>}
      dataObjectName={OnboardingDataEventObject.DEMO_CHAT_SHOWCASE_KNOWLEDGE_BASE}
    >
      <Trans id="infobubble-onboarding-chat-showcase-knowledge-base-description">
        Using Front’s native knowledge base, the chatbot can surface relevant articles so customers can get
        the answers they need faster.
      </Trans>
    </EducationTip>
  );
};
